import React from 'react'
import { Link } from 'react-router-dom'
import slider4 from '../../../../assets/img/slider4.webp'

function SliderAbout4Sec1() {
  return (
<section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li>Leading you through a journey of digital excellence</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Leading you through a journey <span>of digital excellence</span></h2>
              <p>With 360 Gigabytes, you can rest assured to find the perfect path to take you to excellence. Over the years we have established ourselves as the leading service provider for Mobile Application Development, Website Design & Development, Web and Graphic Design, E-Commerce Development, Software as a Solution (Saas - cloud solution), Digital Transformation and Product Engineering.
</p>
            </div> 
           <div className='hmslder-img'>
              <img src={slider4} alt='Leading you through a journey of digital excellence' width={1200} height={800} loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default SliderAbout4Sec1
